import { createContext } from 'use-context-selector'

import { IAvatarContext } from '.'

export const AvatarContext = createContext<IAvatarContext>({} as IAvatarContext)
